import { render, staticRenderFns } from "./TheLanguageSwitcherItem.vue?vue&type=template&id=1c150452"
import script from "./TheLanguageSwitcherItem.vue?vue&type=script&lang=js"
export * from "./TheLanguageSwitcherItem.vue?vue&type=script&lang=js"
import style0 from "./TheLanguageSwitcherItem.vue?vue&type=style&index=0&id=1c150452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports